import { Component, ElementRef, OnInit, QueryList, ViewChildren } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ApiService } from '../../services/API/api.service';
import { AlertService } from '../../services/Alert/alert.service';
import { jwtDecode } from 'jwt-decode';

@Component({
  selector: 'app-sign-in',
  templateUrl: './sign-in.component.html',
  styleUrls: ['./sign-in.component.scss']
})
export class SignInComponent implements OnInit {

  signInForm: FormGroup;
  isLoading: boolean = false;
  userEmail = '';
  disableBtnBeforeResendOTP: boolean = false;
  currentStep: number = 1;
  resetForm: FormGroup;
  countdown = 0;
  countdownInterval: any;
  otpCodeForm: FormGroup;
  @ViewChildren('otp1,otp2,otp3,otp4,otp5,otp6') otpInputs!: QueryList<ElementRef>;
  isResending: boolean = false;
  otp: string[] = ['', '', '', '','',''];

  constructor(private apiService: ApiService,private alertService: AlertService,private fb: FormBuilder) {
    this.signInForm = this.fb.group({
      phone: ['', [Validators.required]],
      password: ['', [Validators.required, Validators.minLength(6)]]
    });
    this.resetForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]]
    });
    this.otpCodeForm = this.fb.group({
      otp_code: ['', [Validators.required, Validators.minLength(6), Validators.maxLength(6)]]
    });
  }

  ngOnInit(): void {
  }

  login(){
    this.isLoading = true;
    console.log(this.signInForm);
    if (this.signInForm.valid) {
      const formData = new FormData()
      formData.append('password', this.signInForm.value.password);
      const isEmail = this.signInForm.value.phone.includes('@');
      if(isEmail){
        formData.append('email', this.signInForm.value.phone);
      }else{
        formData.append('phone', this.signInForm.value.phone);
      }
      this.apiService.signIn(formData).subscribe((response: any) => {
        const isVerified = response.data.user.is_verified
        console.log(isVerified)
        if(isVerified == 1){
          localStorage.setItem('fontana_token', response.data.token);
          localStorage.setItem('fontana_userData', JSON.stringify(response.data.user));
          const token = localStorage.getItem('fontana_token')?.toString();
          const data = jwtDecode(token);
          const exp = data['exp'];
          localStorage.setItem('fontana_expDate', JSON.stringify(exp));
          this.alertService.success('Logged in successfully');
          sessionStorage.removeItem('guestMode'); 
          sessionStorage.removeItem('cartItems');
          sessionStorage.removeItem('favoriteItems');
          sessionStorage.removeItem('cartCount');
          sessionStorage.removeItem('customCartItems');
          sessionStorage.removeItem('fontana_token_to_verify');
          localStorage.removeItem('fontana_token_to_verify');
          setTimeout(() => {
            window.location.href = '/';
          }, 2000);
        }else{
          localStorage.setItem('fontana_token_to_verify', response.data.token);
          this.alertService.danger('Please verify your email');
          this.userEmail = response.data.user.email
          this.sendOtpAfterLoinFail();
          this.isLoading = false;
        }
      }, (error: any) => {
        this.alertService.danger(error.error.message);
        this.isLoading = false;
      });
    }
  }

  enableGuestMode(){
    sessionStorage.setItem('guestMode', 'true');
    localStorage.removeItem('fontana_token_to_verify');
    window.location.href = '/';
  }

  sendOtpAfterLoinFail() {
    this.disableBtnBeforeResendOTP = true;
    $('#signinFormContainer').addClass('d-none');
    $('#codeOTPErrorWhenLoginContainer').removeClass('d-none');
    // Call your backend to send OTP
    console.log('OTP sent to', this.userEmail);
    if(this.userEmail.includes('@')){
      this.resetForm.patchValue({email: this.userEmail});
    }
  }

  sendOtpToMailIfLoginFailed() {
    // this.isResending = true
    this.resetForm.markAllAsTouched();
    if(this.resetForm.valid) {
      this.isLoading = true;
      this.apiService.sendOtpToMailAfterSignup(this.resetForm.value).subscribe({
        next: response => {
          if(response.success) {
            $('#codeOTPErrorWhenLoginContainer').addClass('d-none');
            $('#verifyOTPWhenLoginContainer').removeClass('d-none');
            this.currentStep = 2;
            this.countdown = 60;
            this.countdownInterval = setInterval(() => {
              if (this.countdown > 0) {
                this.countdown--;
              } else {
                this.disableBtnBeforeResendOTP = false;
                clearInterval(this.countdownInterval);
              }
            }, 1000);
            this.alertService.success(response.message);
          }
          this.isLoading = false;
        }, 
        error: (error: any) => {
          this.alertService.danger(error.error.message);
          this.isLoading = false;
        }
      });
    }
  }

  moveToNext2(event: any, index: number) {
    const input = event.target;
    const value = input.value;
    
    // Update the hidden OTP field
    const otpArray = this.otpCodeForm.value.otp_code.split('');
    otpArray[index - 1] = value;
    this.otpCodeForm.patchValue({ otp_code: otpArray.join('') });
    
    // Move to next input
    if(value.length === 1 && index < 6) {
      this.otpInputs.toArray()[index].nativeElement.focus();
    }
  }

  verifyOtp2() {
    this.otpCodeForm.markAllAsTouched();
    
    // console.log(this.otpInputs)
    if(this.otpCodeForm.valid) {
      this.isLoading = true;
      const otpCode = this.otp.join('');
      const formData = new FormData();
      formData.append('otp_code', this.otpCodeForm.value.otp_code);
      formData.append('type', "verify");
      this.apiService.verifyOtpAfterSignup(formData).subscribe({
        next: response => {
          if(response.success) {
            // this.currentStep = 3;
            this.alertService.success(response.message);
            setTimeout(() => {
              window.location.reload();
            }, 1500);
          }
          this.isLoading = false;
        }, 
        error: (error: any) => {
          this.alertService.danger(error.error.message);
          this.isLoading = false;
        }
      });
    }
  }

  resendOtp() {
    this.isResending = true;
    console.log(this.userEmail)
    this.resetForm.patchValue({email: this.userEmail});
    this.apiService.resentOtp(this.resetForm.value).subscribe({
      next: response => {
        if(response.success) {
          this.alertService.success(response.message);
          this.disableBtnBeforeResendOTP = true;
          this.countdown = 60;
          this.countdownInterval = setInterval(() => {
            if (this.countdown > 0) {
              this.countdown--;
            } else {
              this.disableBtnBeforeResendOTP = false;
              clearInterval(this.countdownInterval);
            }
          }, 1000);
        }
        this.isResending = false;
      }, 
      error: (error: any) => {
        this.alertService.danger(error.error.message);
        this.isResending = false;
      }
    });
  }

}
